import { useCallback, useEffect } from 'react';
import { usePromiseCallback } from './use-promise-callback';

const DefaultOptions = {
  manual: false,
};

export const usePromise = (getPromise, dependencies, options = DefaultOptions) => {
  const { execute, ...requestData } = usePromiseCallback(getPromise, dependencies, options);
  const executeWithPromiseCounterManipulation = useCallback(
    () => { execute({ manipulatePromiseCounter: true }); },
    [execute]
  );
  useEffect(executeWithPromiseCounterManipulation, dependencies);

  return requestData;
};
